import React from 'react'
import Logo from '../logo/ROO.png'

const RealLogo = () => {
  return (
<>
    <img style={{
      width:"150px",
    }} src={Logo} alt="Real Logo" />
</>
  )
}

export default RealLogo